//  -*-web-*-
import {marketClosed, timeZone} from './Mappings.js';

// --------------------------------------------------------------------
// Find most remote possible future day counting from right now -
// given the data we have.
// --------------------------------------------------------------------
export function maxFutureTime(realtime, country)
{
    const scenario_len = 0;
    var ltime = localTime(country);
    var hours = ltime.getHours() + ltime.getMinutes()/60;
    var weekday = ltime.getDay(); // Sun=0, Mon=1, ...
    var weekend = (weekday === 0 || weekday === 6);
    var extraday = (realtime && (hours > marketClosed(country) || weekend)) ? 1 : 0;

    // If there are no extra days to be added make sure a weekend day
    // is set back to the previous Friday
    if (extraday + scenario_len <= 0) {
	if (weekday === 0) ltime.setDate(ltime.getDate()-2); // Sun=>Fri
	else if (weekday === 6) ltime.setDate(ltime.getDate()-1); // Sat=>Fri
    } else {
	// Check scenario length and/or extraday and add days accordingly
	for (var i=0; i<scenario_len+extraday; i++) {
	    ltime.setDate(ltime.getDate()+1);
	    weekday = ltime.getDay(); // Sun=0, Mon=1, ...
	    if (weekday === 0) ltime.setDate(ltime.getDate()+1); // Sun=>Mon
	    else if (weekday === 6) ltime.setDate(ltime.getDate()+2); // Sat=>Mon
	}
    }
    return ltime;
}

// --------------------------------------------------------------------
// Return the local time for the country 
// --------------------------------------------------------------------
function localTime(country)
{
    var tz = timeZone(country);
    var timeHere = new Date();
    return new Date(timeHere.toLocaleString('en-US', { timeZone: tz }));
}
